// extracted by mini-css-extract-plugin
export default {"details-pane-name-cell":"DetailsPaneTableRow_details-pane-name-cell__+iNFW","details-pane-general-cell":"DetailsPaneTableRow_details-pane-general-cell__KxNP3"};